module.exports = __webpack_public_path__ + "static/media/slide-5.7507a2f0.png";